import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedModule } from '../../_shared/shared.module';
import { AlertService } from '../../_shared/services/alert.service';
import { UtilService } from '../../_shared/services/util.service';

import { OccupancyType } from '../shared/occupancy-type.model';
import { OccupancyTypeModalService } from '../shared/occupancy-type-modal.service';
import { OccupancyTypeService } from '../shared/occupancy-type.service';

@Component({
  selector: 'app-occupancy-type-detail',
  templateUrl: './occupancy-type-detail.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class OccupancyTypeDetailComponent implements OnInit {
  constructor(
    private occupancyTypeService: OccupancyTypeService,
    private occupancyTypeModalService: OccupancyTypeModalService,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private utilService: UtilService
  ) {}

  @Input() occupancyType: OccupancyType;
  @Input() mode: string;
  @Input() defaultLanguage;
  @Input() additionalLanguages;
  @Input() isModal = false;

  @Output() private savedOccupancyType = new EventEmitter<OccupancyType>();
  @Output() private canceledOccupancyType = new EventEmitter();

  form: FormGroup;
  formSubmited = false;

  createMode = false;
  editMode = false;
  viewMode = false;

  serverErrors = [];
  sendingForm = false;

  private occupancyTypeCopy;

  ngOnInit() {
    this.setOccupancyTypeForm();

    if (this.occupancyType.id) {
      this.setItemOptions(this.occupancyType, this.mode);

      this.form.patchValue(this.occupancyType);
    } else {
      this.createMode = true;
    }
  }

  // Referenced from app-translation-options
  onOpenedTranslation(language) {
    this.occupancyTypeModalService.openOccupancyTypeTranslation(this.occupancyType, language);
  }

  // Referenced from app-item-detail-form-actions
  onSavedOccupancyType() {
    this.formSubmited = true;

    if (this.form.invalid) {
      this.serverErrors = [];

      return;
    }

    const formData = this.form.value;

    const fields = ['name', 'occupancy'];

    if (
      this.editMode &&
      !fields.some((field) => formData[field] !== this.occupancyTypeCopy[field])
    ) {
      this.onCanceled();
      return;
    }

    this.sendingForm = true;

    this.occupancyTypeService
      .saveOccupancyType(this.occupancyType.id, formData, this.defaultLanguage.lang)
      .subscribe({
        next: (response) => {
          let msg = '';

          if (this.editMode) {
            msg = 'MODIFIED_OCCUPANCY_TYPE';

            // needed if we want to keep the page opened or if used in page
            // this.occupancyType = response;
            // this.setItemOptions(response);
          } else {
            msg = 'NEW_ADDED_OCCUPANCY_TYPE';
            // this.occupancyType = response; // reload item - needed ?
          }

          this.alertService.open(msg);

          // this.setItemOptions(response);

          this.sendingForm = false;

          this.savedOccupancyType.emit(response);
        },
        error: (response) => {
          this.serverErrors = this.utilService.setFormServerErrors(response.error.errors);

          this.sendingForm = false;
        },
      });
  }

  // Referenced from app-item-detail-form-actions
  onCanceled() {
    // if (this.editMode) {
    //   this.cancelEdit();
    //   return;
    // }

    this.canceledOccupancyType.emit();
  }

  // Referenced from app-item-detail-form-actions
  onEditedOccupancyType() {
    this.editMode = true;
    this.viewMode = false;
  }

  // private cancelEdit() {
  //   this.occupancyType = this.occupancyTypeCopy;
  //   this.setItemOptions(this.occupancyType);
  // }

  private setItemOptions(occupancyType, mode = '') {
    this.createMode = false;
    this.editMode = false;
    this.viewMode = true;

    if (mode === 'edit') {
      this.onEditedOccupancyType();
    }

    // this.occupancyTypeCopy = JSON.parse(JSON.stringify(occupancyType));
    this.occupancyTypeCopy = { ...occupancyType };
  }

  private setOccupancyTypeForm() {
    this.form = this.formBuilder.group({
      name: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      occupancy: [
        '',
        {
          validators: [
            Validators.required,
            // Validators.min(1), used it in html to limit the input length
            Validators.pattern(this.utilService.selectInputPattern('numbers')),
          ],
        },
      ],
    });
  }
}

// Validators.max(999), used it in html to limit the input length
// updateOn: 'blur',

/*

const formData = this.utilService.deleteNullFields(fields, this.form.value);

 this.form = this.formBuilder.group({
      name: [
        this.occupancyType.name,
        {
          validators: [
            Validators.required,
            // Validators.maxLength(100), used it in html to limit the input length
            // Validators.pattern(this.utilService.selectInputPattern('text')),
          ],
          updateOn: 'blur',
        },
      ],
      occupancy: [
        this.occupancyType.occupancy,
        {
          validators: [
            Validators.required,
            // Validators.min(1), used it in html to limit the input length
            Validators.pattern(this.utilService.selectInputPattern('numbers')),
          ],
        },
      ],
    });

*/
